(function () {
    'use strict';

    angular
        .module('szallodak-news', []);
})();
